import React from 'react';
const NotFoundPage = () => (
    <div style={{padding:'2rem',fontFamily:'sans-serif',background:'#f5f0e8',minHeight:'100vh'}}>
        <h2 style={{color:'#1e2a3a'}}>NotFoundPage</h2>
        <p style={{color:'#4a5060'}}>Building this page now...</p>
    </div>
);
export default NotFoundPage;
